import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/Hero.css';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <motion.div 
          className="hero-text-container"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="hero-title">Digi Bean  Rewards.</h1>
          <h2 className="hero-subtitle">Get Koffie Tokens.</h2>
          <p className="hero-description">
            Life moves fast. So do we. Whether it's a well-deserved coffee on a busy day or popcorn for movie night, 
            Wing delivers groceries, food, and more in as little as 15 minutes.
          </p>
          <motion.a 
            href="#get-delivery" 
            className="btn hero-cta"
            whileHover={{ scale: 1.05, backgroundColor: "#e6b800" }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="dot">•</span> Get delivery
          </motion.a>
        </motion.div>
      </div>
      <motion.div 
        className="solutions-image-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <div className="hero-image solutions-image">
          {/* This will be replaced with an actual image in production */}
        </div>
      </motion.div>
      <div className="hero-slider">
        <div className="slider-dots">
          <span className="dot active"></span>
          <span className="dot"></span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
